import React from 'react';
import { Link } from 'gatsby';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/theme.scss';
import { Container, Row, Col } from 'reactstrap';
import { Parallax } from 'react-scroll-parallax';
import { GoFile, GoStar } from 'react-icons/go';
import { FiChevronRight } from 'react-icons/fi';
import { HiArrowNarrowRight } from 'react-icons/hi';
import SEO from '../components/seo';
// Asset
import roundedImg1 from '../images/rounded-img1.png';
import roundedImg3 from '../images/rounded-img3.png';
import focusImg from '../images/focus.png';
import testimonialImg from '../images/testimonial.png';
import userAvatar from '../images/user-avatar.png';
import karinaAvatar from '../images/karina.jpg';
import softwareStack from '../images/stack.svg';
import charliIcon from '../images/charli-icon.svg';
import circle from '../images/circle.svg';
import greenCircle from '../images/green-circle.svg';
import redCircle from '../images/red-circle.svg';
import redBubble from '../images/red-bubble.svg';
import purpleBubble from '../images/purple-circle.svg';
import greenBubble from '../images/green-bubble.svg';
import blueBubble from '../images/blue-bubble.svg';
import icon1 from '../images/icon1.svg';
import icon2 from '../images/icon2.svg';
import icon3 from '../images/icon3.svg';
import redNote1 from '../images/red-note1.svg';
import redNote2 from '../images/red-note2.svg';
import purpleNote from '../images/purple-note.svg';
import yellowNote from '../images/yellow-note.svg';
// import addNewSubscriber from "../action/addNewSubscriber";
const IndexPage = () => {
  // const [subscriberEmail, setSubscriberEmail] = useState("");
  // const [validEmail, setValidatedEmail] = useState(false);
  // const [invalidEmail, setInvalidatedEmail] = useState(false);
  // const sendContact = async () => {
  //   if (
  //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
  //       subscriberEmail
  //     )
  //   ) {
  //     setValidatedEmail(true);
  //     setInvalidatedEmail(false);
  //     addNewSubscriber(subscriberEmail);
  //   } else {
  //     setValidatedEmail(false);
  //     setInvalidatedEmail(true);
  //     return false;
  //   }
  // };
  return (
    <>
      <SEO
        title="Home | CharliAI"
        description="A.I. that makes your work flow"
        image="https://resource.charli.ai/wp-content/uploads/2020/10/rounded-img1.png"
      />
      <Container fluid className="section-banner">
        <Row>
          <Col md="12" lg="6">
            <h1 className="page-header">
              Meet Charli, your new chief of{' '}
              <span className="text-orange">‘stuff’</span>
            </h1>
            <p>
              Get your content under control. Let Charli organize your “stuff.”
              Easily find and share everything that matters.
            </p>
            <div className="form-wrapper">
              {/* <FormGroup className="subscription-form">
                <Input
                  placeholder="Your Email"
                  valid={validEmail}
                  invalid={invalidEmail}
                  onChange={(e) => setSubscriberEmail(e.target.value)}
                />
                {validEmail ? (
                  <FormFeedback valid={true}>
                    Thanks for subscribing to our newsletter!
                  </FormFeedback>
                ) : (
                  ""
                )}
                {invalidEmail ? (
                  <FormFeedback invalid={true}>
                    You have entered an invalid email address!
                  </FormFeedback>
                ) : (
                  ""
                )}
              </FormGroup> */}
              {/* <div className="button-teal">
                <Button onClick={sendContact}>Request Access</Button>
              </div> */}
              <div className="button-teal">
                <a
                  href="https://charliai.typeform.com/to/IhzcZhjI"
                  target="_blank"
                  rel="noreferrer"
                >
                  Try for Free
                </a>
              </div>
            </div>
          </Col>
          <Col md="12" lg="6">
            <div className="mobile-device wow">
              <div className="mobile-device__frame">
                <video
                  className="mobile-device__video"
                  src="https://pacemediafiles.s3-us-west-2.amazonaws.com/Charli-AI/charliAI-demo1.mp4"
                  autoPlay
                  playsInline
                  loop
                  muted
                  type="video/mp4"
                />
              </div>
            </div>
            <Parallax className="circle wow" y={[80, -20]} tagOuter="figure">
              <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
            </Parallax>
            <img
              src={roundedImg1}
              className="rounded-img-1 wow"
              alt="charli-ai"
            />
            <Parallax
              className="purple-dot wow"
              y={[20, -200]}
              tagOuter="figure"
            >
              <img src={purpleBubble} alt="charli-ai" />
            </Parallax>
          </Col>
        </Row>
      </Container>
      <Container fluid className="homepage-fluid-content">
        <Row className="homepage-fluid-content--wrapper">
          <Col sm="12" md="7" className="homepage-fluid-content--title">
            <h2>
              Manage all the things in{' '}
              <span>
                one place
                <i className="underline wow" />
              </span>
            </h2>
            <p>
              Charli keeps track of all your content, stuff for your work and
              life. Just send stuff to Charli when you need something organized,
              just like an IRL assistant. Part workflow automation, organization
              wizard and search engine.
            </p>
          </Col>
          <Col md="12" lg="9" className="section-interactive">
            <div className="ytb-player">
              <iframe
                title="Manage your content better with Charli"
                width="768"
                height="432"
                src="https://www.youtube.com/embed/jCzT3kumTHc"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <Link className="teal-link-button" to="/product/">
              <h4>
                Take the Product Tour <HiArrowNarrowRight />
              </h4>
            </Link>
          </Col>
          <Parallax className="red-circle wow" y={[20, -100]} tagOuter="figure">
            <img src={redBubble} alt="charli-ai" />
          </Parallax>
          <Parallax className="circle-2 wow" y={[20, -100]} tagOuter="figure">
            <img src={circle} alt="charli-ai" />
          </Parallax>
        </Row>
      </Container>
      <Container fluid className="homepage-fluid-content-2">
        <Container>
          <Row className="hompage-fluid-content-2--wrapper">
            <Col md="12" lg="7" className="homepage-fluid-content-2--title">
              <h3>Put #organization on autopilot</h3>
              <p>
                We all want to spend less time finding, and sharing information,
                but it takes time, effort, and patience to get organized. So we
                end up with a lot of stuff in a lot of different places.
              </p>
            </Col>
            <Col md="12" lg="12">
              <div className="hompage-fluid-content-2--text-wrapper">
                <div className="intro1 wow">
                  <p className="wow">
                    We spend 60% of our working day on admin
                  </p>
                </div>
                <div className="intro2 wow" data-wow-delay="1.5s">
                  <p className="wow">19% looking for information</p>
                </div>
              </div>
              <div className="img-wrapper">
                <img
                  src={roundedImg3}
                  className="rounded-img-3 wow"
                  alt="charli-ai"
                />
                <img src={focusImg} className="focus-img wow" alt="charli-ai" />
                <Parallax className="green-bubble wow" tagOuter="figure">
                  <img src={greenBubble} alt="charli-ai" />
                </Parallax>
              </div>
            </Col>
          </Row>
          <Row className="hompage-fluid-content-2--wrapper">
            <Col md="12" lg="5" className="homepage-fluid-content-2--offload">
              <h3>Never lose track of an important document again</h3>
              <p>
                Declutter your mind, your inbox, and your desk. Send Charli your
                important documents and get auto-generated folder structures,
                easy retrieval and even easier sharing.
              </p>
            </Col>
            <Col
              md="12"
              lg="7"
              className="homepage-fluid-content-2--interaction"
            >
              <div className="chat-wrapper">
                <div className="user-chat wow" data-wow-delay="1s">
                  <p className="wow" data-wow-delay="1.5s">
                    Show me all my #marketing
                  </p>
                  <p className="wow" data-wow-delay="2s">
                    documents
                  </p>
                </div>
                <img
                  className="user-avatar wow"
                  src={userAvatar}
                  alt="charli-ai"
                />
              </div>
              <div className="charli-chat-wrapper">
                <img
                  src={charliIcon}
                  className="wow"
                  alt="charli-ai"
                  data-wow-delay="2.5s"
                />
                <div className="charli-chat wow" data-wow-delay="3.5s">
                  <p>
                    I’m looking into this right away, and will let you know.
                  </p>
                </div>
              </div>
              <div className="charli-chat-wrapper">
                <img
                  src={charliIcon}
                  alt="charli-ai"
                  className="wow"
                  data-wow-delay="4s"
                />
                <div className="charli-chat wow" data-wow-delay="4.5s">
                  <GoFile size="2em" />
                  <p>
                    View Documents <FiChevronRight />
                  </p>
                </div>
              </div>
              <div className="chat-wrapper">
                <div className="user-chat wow" data-wow-delay="5.5s">
                  <p className="wow" data-wow-delay="6s">
                    Thanks Charli!
                  </p>
                </div>
                <img
                  src={userAvatar}
                  alt="charli-ai"
                  className="wow"
                  data-wow-delay="5s"
                />
              </div>
            </Col>
          </Row>
        </Container>
        <Parallax className="circle-3 wow" y={[-80, -200]} tagOuter="figure">
          <img src={greenCircle} alt="charli-ai" />
        </Parallax>
        <Parallax className="blue-bubble wow" y={[20, -150]} tagOuter="figure">
          <img src={blueBubble} alt="charli-ai" />
        </Parallax>
        <Parallax className="circle-4 wow" y={[20, -50]} tagOuter="figure">
          <img src={greenCircle} alt="charli-ai" />
        </Parallax>
      </Container>
      <Container fluid className="homepage-note-section">
        <Parallax className="red-note1 wow" y={[-100, -180]} tagOuter="figure">
          <img src={redNote1} alt="charli-ai" />
        </Parallax>
        <Parallax className="purple-note wow" y={[20, -20]} tagOuter="figure">
          <img src={purpleNote} alt="charli-ai" />
        </Parallax>
        <Parallax className="red-note2 wow" y={[-100, -180]} tagOuter="figure">
          <img src={redNote2} alt="charli-ai" />
        </Parallax>
        <Parallax
          className="yellow-dec-note wow"
          y={[20, -20]}
          tagOuter="figure"
        >
          <img src={yellowNote} alt="charli-ai" />
        </Parallax>
        <Container className="homepage-note-section--container">
          <Row className="homepage-note-section--notes">
            <Col sm="12">
              <h2>Just ask Charli to…</h2>
            </Col>
            <Col sm="12" md="4" className="homepage-note-section--wrapper">
              <div className="yellow-note">
                <div className="ribbon">
                  <div className="label">Early Access</div>
                </div>
                <img src={icon1} alt="charli-ai" />
                <h4 className="highlight wow">Organize content</h4>
                <p>Tag, file, retrieve and organize important documents.</p>
              </div>
            </Col>
            <Col sm="12" md="4" className="homepage-note-section--wrapper">
              <div className="blue-note">
                <div className="ribbon">
                  <div className="label">Coming Soon</div>
                </div>
                <img src={icon2} alt="charli-ai" />
                <h4 className="highlight wow">Share content</h4>
                <p>
                  Find and share files with collaborators by asking Charli, or
                  get easy links to your inbox.
                </p>
              </div>
            </Col>
            <Col sm="12" md="4" className="homepage-note-section--wrapper">
              <div className="teal-note">
                <div className="ribbon">
                  <div className="label">Coming Soon</div>
                </div>
                <img src={icon3} alt="charli-ai" />
                <h4 className="highlight wow">Automate workflows</h4>
                <p>
                  Organization is just the beginning. Save everything, find
                  stuff faster and start working smarter. Manage tasks, get
                  reminders, and schedule meetings.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm="12" md="12" className="homepage-fluid-content--title">
              <h2>
                Eliminating productivity killers for businesses, startups and
                connected workers <br />
                <span>
                  everywhere.
                  <i className="underline wow" />
                </span>
              </h2>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="homepage-testimonial-section">
        <Parallax className="circle-5 wow" y={[20, -20]} tagOuter="figure">
          <img src={redCircle} alt="charli-ai" />
        </Parallax>
        <Row className="testimonial-container">
          <Col sm="12" md="6" className="testimonial-img">
            <img src={testimonialImg} alt="charli-ai" />
          </Col>
          <Col sm="12" md="6" className="homepage-testimonial-section--wrapper">
            <div className="review-wrapper">
              <p>
                “Running a fast-growing digital agency is no easy feat, but
                Charli’s taken time-consuming tasks off my plate. I use Charli
                to organize my Google Drive, declutter my inbox and declutter my
                mind!”
              </p>
              <div className="review-content">
                <img src={karinaAvatar} alt="reviewer" />
                <div className="review-text">
                  <p className="author">Karina, Sparked Digital</p>
                  <div className="stars-rating">
                    <GoStar size="1em" />
                    <GoStar size="1em" />
                    <GoStar size="1em" />
                    <GoStar size="1em" />
                    <GoStar size="1em" />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md="12" className="homepage-fluid-content--title">
            <h2>
              Connect to the apps you already <br />
              <span>
                know and love.
                <i className="underline wow" />
              </span>
            </h2>
            <p className="sub-title">
              Let Charli manage your stuff across your software stack:
            </p>
            <img src={softwareStack} alt="charli-ai" />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default IndexPage;
